"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProtectedPage = void 0;
const react_1 = __importStar(require("react"));
const hooks_1 = require("../../../store/hooks");
const reducers_1 = require("../../../store/reducers");
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const react_jwt_1 = require("react-jwt");
const axios_1 = __importDefault(require("axios"));
const jwt_decode_1 = __importDefault(require("jwt-decode"));
function ProtectedPage({ children, navigation }) {
    const auth = (0, hooks_1.useAppSelector)(reducers_1.selectAuth);
    const UNAUTHORIZED = 401;
    axios_1.default.interceptors.response.use(response => response, error => {
        const { status } = error.response;
        if (status === UNAUTHORIZED) {
            async_storage_1.default.multiRemove(['JWT', 'User']);
            navigation.navigate('Login');
        }
        return Promise.reject(error);
    });
    (0, react_1.useEffect)(() => {
        return navigation.addListener('focus', () => {
            setTimeout(() => {
                if (!auth.isAuthenticated) {
                    navigation.navigate('Login');
                    return;
                }
                if (!auth.isTermsAgree || !auth.isPrivacyPolicyAgree) {
                    navigation.navigate('ConfirmTerms');
                    return;
                }
            }, 1500);
        });
    }, [auth.isAuthenticated, auth.isTermsAgree, auth.isPrivacyPolicyAgree]);
    (0, react_1.useEffect)(() => {
        const checkToken = async () => {
            const token = await async_storage_1.default.getItem('JWT');
            if (token) {
                const decodedToken = (0, jwt_decode_1.default)(token);
                if (!(!(0, react_jwt_1.isExpired)(token) || (decodedToken && !('exp' in decodedToken)))) {
                    await async_storage_1.default.multiRemove(['JWT', 'User']);
                    navigation.navigate('Login');
                }
            }
            else {
                navigation.navigate('Login');
            }
        };
        checkToken();
    }, []);
    return react_1.default.createElement(react_1.default.Fragment, null, children);
}
exports.ProtectedPage = ProtectedPage;
